<template>
  <div
    class="confirm-account tw-bg-white tw-w-96 tw-h-auto tw-rounded-3xl tw-relative tw-mx-auto"
  >
    <div
      class="logo tw-w-32 md tw-h-32 tw-flex tw-items-center tw-bg-white tw-rounded-full tw-absolute tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2"
    >
      <img :src="logo" class="tw-w-full" />
    </div>
    <div class="tw-mt-14 tw-w-full tw-h-auto tw-p-4 tw-flex tw-flex-col">
      <div class="tw tw-mt-4 tw-text-left">
        <p>ชื่อบัญชี:</p>
        <input
          disabled
          v-model="user.username"
          class="tw tw-rounded-md tw-w-full tw-py-2 tw-px-2 tw-border"
          type="text"
        />
      </div>
      <div class="tw tw-mt-4 tw-text-left">
        <p>รหัสยืนยัน:</p>
        <input
          v-model="code"
          class="tw tw-rounded-md tw-w-full tw-py-2 tw-px-2 tw-border"
          type="text"
        />
      </div>
      <div
        class="tw-text-left tw-flex tw-flex-row tw-justify-between tw-items-center tw-mt-4"
      >
        <span>
          ไม่ได้รับรหัสยืนยัน?
          <span class="tw-text-primary tw-cursor-pointer" @click="onResendOtp"
            >ส่งรหัสยืนยันอีกครั้ง</span
          >
        </span>
        <button
          @click="onVerify"
          class="tw-bg-primary tw-text-white tw-p-2 tw-rounded-md tw-w-auto"
        >
          ยืนยัน
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from "@aws-amplify/auth";
export default {
  name: "ConfirmAccount",
  props: ["user"],
  data() {
    return {
      logo: require("@/assets/v2/logo/water_recovered_with_text.png"),
      code: "",
    };
  },
  methods: {
    async onVerify() {
      console.log("onVerify");
      const code = this.code.trim();
      if ([undefined, null, ""].indexOf(code) >= 0) {
        return;
      }
      try {
        const response = await Auth.confirmSignUp(this.user.username, code);
        if (response) {
          const user = await Auth.signIn(
            this.user.username,
            this.user.password
          );
          console.log(user);
          if (!user) {
            this.$buefy.snackbar.open(`Incorrect username or password.`);
            return;
          }
          this.$router.push({
            name: "Profile",
            params: {
              username: user["username"],
            },
          });
        }
      } catch (error) {
        console.log(error);
        if (error.code === "NotAuthorizedException") {
          this.$router.go();
        }
        const notif = this.$buefy.notification.open({
          duration: 5000,
          message: error.message,
          position: "is-top",
          type: "is-danger",
        });
      }
    },
    async onResendOtp() {
      try {
        const response = await Auth.resendSignUp(this.user.username);
        console.log(response);
        const notif = this.$buefy.notification.open({
          duration: 5000,
          message: `ทำการส่งรหัสยืนยันไปยัง ${response.CodeDeliveryDetails.Destination} แล้ว`,
          position: "is-top",
          type: "is-success",
        });
      } catch (error) {
        const notif = this.$buefy.notification.open({
          duration: 5000,
          message: error.message,
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style></style>
